module.exports = __webpack_public_path__ + "static/media/plitvice-lakes-croatia.5c4df8bb.jpg";